import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useUpdateTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.ITemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			template,
			impersonationContext,
		}: {
			template: Api.ITemplate;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/${encodeURIComponent(template.id)}`,
					impersonationContext,
				}),
				`PATCH`,
				template
			),
		onError,
		onSuccess,
	});
}
